var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowTop = function SvgArrowTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 .94 3.187 7.75h6.06V19h1.5V7.75h6.062zm3.188 5.31H6.81L10 3.06z",
    clipRule: "evenodd"
  })));
};
export { SvgArrowTop as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOS45OTkxMSAwLjkzOTQ1M0wzLjE4ODIyIDcuNzUwMDFMOS4yNDg3MiA3Ljc1MDA2TDkuMjQ4NzIgMTlIMTAuNzQ4N0wxMC43NDg3IDcuNzUwMDdMMTYuODA5NiA3Ljc1MDEyTDkuOTk5MTEgMC45Mzk0NTNaTTEzLjE4ODMgNi4yNTAwOUw2LjgwOTYyIDYuMjUwMDRMOS45OTkwNiAzLjA2MDc2TDEzLjE4ODMgNi4yNTAwOVoiLz4KPC9zdmc+Cg==";